module.exports = __webpack_public_path__ + "static/media/delete.b17a93ee.svg";